import { TextComponent } from 'design/text/textComponents';
import React from 'react';

import { createClassName } from 'utils/createClassName';

import './logoStyles.scss';

type Props = {
  theme?: 'primary' | 'admin';
  subTitle?: string;
};

export const LogoComponent = (props: Props) => {
  const { subTitle, theme = 'primary' } = props;

  const createLogoClassName = createClassName('logo');

  const wrapperClassName = createLogoClassName('wrapper', { theme });

  const primaryTitleClassName = createLogoClassName('primaryTitle', { theme });

  const secondaryTitleClassName = createLogoClassName('secondaryTitle', {
    theme,
  });

  return (
    <div className={wrapperClassName}>
      <div className={primaryTitleClassName}>
        <TextComponent family="futura" size="m">
          AGM
        </TextComponent>
      </div>
      {subTitle && <div className={secondaryTitleClassName}>{subTitle}</div>}
    </div>
  );
};
